<div class="gw-p-6 gw-space-y-4">
  <h2 class="gw-text-lg gw-font-semibold gw-text-text-primary">
    {{ 'features.communications.modal.title' | translate }}
  </h2>
  <div class="gw-flex gw-justify-center gw-w-full">
    <img
      [src]="data.qrCode"
      alt="QR Code"
      class="gw-max-w-[50%] gw-mx-auto gw-rounded-lg"
    />
  </div>
  <p class="gw-text-sm gw-text-text-secondary gw-text-center">
    {{ 'features.communications.modal.description' | translate }}
  </p>
  <div class="gw-flex gw-justify-end gw-pt-2">
    <button tuiButton appearance="primary" (click)="close()">
      {{ 'features.communications.buttons.close' | translate }}
    </button>
  </div>
</div>
